import React, { useState, useEffect } from 'react';
import {
  subscribeProjects,
  subscribeExpenses,
  subscribeInvoices,
  subscribeSettings,
  subscribePendingExpenseCount,
} from '../services/expenseFirestore';
import { ADMIN_TABS } from '../constants/expenseConstants';
import { TableSkeleton } from './ui/Skeleton';
import ProjectManagement from './expense/ProjectManagement';
import ExpenseDashboard from './expense/ExpenseDashboard';
import ProfitLoss from './expense/ProfitLoss';
import FinancialAnalytics from './expense/FinancialAnalytics';
import InvoiceModule from './expense/InvoiceModule';
import './ExpenseManagement.css';
import './ui/Modal.css';
import './expense/ExpenseDashboard.css';
import './expense/FinancialAnalytics.css';

const TAB_LABELS = {
  projects: 'Projects',
  expenses: 'Expenses',
  'profit-loss': 'Profit & Loss',
  'financial-analytics': 'Financial Analytics',
  invoices: 'Invoices',
};

function ExpenseTabLabel({ tab, pendingCount }) {
  if (tab === 'expenses' && pendingCount > 0) {
    return (
      <>
        Expenses (<span className="expense-tab-count">{pendingCount}</span>)
      </>
    );
  }
  return TAB_LABELS[tab];
}

export default function ExpenseManagement() {
  const [activeTab, setActiveTab] = useState('projects');
  const [projects, setProjects] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [settings, setSettings] = useState({});
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubs = [
      subscribeProjects(setProjects),
      subscribeExpenses(setExpenses),
      subscribeInvoices(setInvoices),
      subscribeSettings(setSettings),
      subscribePendingExpenseCount(setPendingCount),
    ];
    setLoading(false);
    return () => unsubs.forEach((u) => u());
  }, []);

  const renderTab = () => {
    switch (activeTab) {
      case 'projects':
        return <ProjectManagement projects={projects} loading={loading} />;
      case 'expenses':
        return <ExpenseDashboard expenses={expenses} projects={projects} loading={loading} isAdmin />;
      case 'profit-loss':
        return <ProfitLoss projects={projects} expenses={expenses} invoices={invoices} loading={loading} />;
      case 'financial-analytics':
        return <FinancialAnalytics projects={projects} expenses={expenses} invoices={invoices} loading={loading} />;
      case 'invoices':
        return <InvoiceModule projects={projects} invoices={invoices} settings={settings} loading={loading} />;
      default:
        return null;
    }
  };

  return (
    <div className="expense-management">
      <div className="expense-toolbar">
        <div className="expense-tabs">
          {ADMIN_TABS.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`expense-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              <ExpenseTabLabel tab={tab} pendingCount={pendingCount} />
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="expense-panel"><TableSkeleton rows={6} cols={7} /></div>
      ) : (
        renderTab()
      )}
    </div>
  );
}
